import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { reportError } from "../lib/report";

/** A page that failed to draw: say so, offer a way back, and tell the server what broke. */
export function RouteError() {
  const error = useRouteError();
  const missing = isRouteErrorResponse(error) && error.status === 404;
  useEffect(() => {
    if (!missing) reportError("render", error);
  }, [error, missing]);
  return (
    <div className="empty-state" role="alert">
      <h2>{missing ? "That page doesn’t exist." : "Something went wrong on this page."}</h2>
      <p>{missing ? "The link may be out of date." : "It’s been reported. Reloading usually gets you going again."}</p>
      <p>
        <button type="button" className="btn primary" onClick={() => location.reload()}>
          Reload
        </button>{" "}
        <a className="btn" href="/brief">
          Go to the brief
        </a>
      </p>
    </div>
  );
}
